import React from "react";

export const IsPowerUserContext = React.createContext<boolean>(false);

export function useIsPowerUser() {
    return React.useContext(IsPowerUserContext);
}
